import * as React from 'react';
import { t } from '@moovly/i18n';
import { ModalContainer } from '@moovly/ui';
import { Library } from '@moovly/clients/lib/resources/libraries/libraries.interfaces';
import LibraryCreateUpdateContainer from '../containers/LibraryCreateUpdateContainer';
import { DefaultModalProps } from '../../../types/modal';

interface EditLibraryModalProps extends DefaultModalProps {
  library: Library;
}

export const EditLibraryModal: React.FC<EditLibraryModalProps> = ({ library, closeModal, setOpen }) => {
  return (
    <ModalContainer
      setOpen={setOpen}
      isOpen={!!library}
      title={t('libraries.update.title')}
      confirmButtonText={t('libraries.update.button')}
    >
      <LibraryCreateUpdateContainer onClose={closeModal} library={library} />
    </ModalContainer>
  );
};

export default EditLibraryModal;
